import * as React from "react";
import { useEffect, useState } from "react";
import { react2Angular } from "~/Core/React2Angular";
import { useEnumData, EnumModel } from "~/Hooks/Api/Enum";

interface CheckboxGroupProps {
    value: string;
    name: string;
    isCustomProperty: boolean;
    sort: boolean;
    enumClassName: string;
    onChange: (name: string, value: string, isCustomProperty: boolean) => void;
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
    name,
    value,
    isCustomProperty,
    sort,
    onChange,
    enumClassName,
}) => {
    let { data } = useEnumData(enumClassName);
    if (sort) {
        data = data?.sort((o, p) => {
            if (o.label < p.label) {
                return -1;
            }
            if (o.label > p.label) {
                return 1;
            }

            return 0;
        });
    }

    const [selectedValues, setSelectedValues] = useState<string[]>(value ? value.split("|") : []);

    useEffect(() => {
        setSelectedValues(value ? value.split("|") : []);
    }, [value]);

    const handleChange = (option: string) => {
        const newValues =
            selectedValues.indexOf(option) !== -1
                ? selectedValues.filter(val => val !== option)
                : [...selectedValues, option];
        setSelectedValues(newValues);
        onChange(name, newValues.join("|"), isCustomProperty);
    };

    return (
        <div>
            {(data ?? []).map(option => (
                <label key={option.value} style={{ display: "block" }}>
                    <input
                        type="checkbox"
                        checked={selectedValues.indexOf(option.value) !== -1}
                        onChange={() => handleChange(option.value)}
                    />
                    {option.label}
                </label>
            ))}
        </div>
    );
};

angular
    .module("insite-admin")
    .component(
        "checkboxGroup",
        react2Angular(CheckboxGroup, ["name", "value", "isCustomProperty", "sort", "onChange", "enumClassName"]),
    );
